export default "__VITE_ASSET__Ca8tpesj__"